import ReactGA from 'react-ga4';

// Initialize Google Analytics
export const initGA = () => {
  // Only initialize if we have a tracking ID configured
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {
      // Configuration options
      gaOptions: {
        // Don't track in development
        debug_mode: process.env.NODE_ENV === 'development',
      },
      gtagOptions: {
        // Anonymize IP addresses for GDPR compliance
        anonymize_ip: true,
      },
    });
    
    console.log('Google Analytics initialized');
  } else {
    console.warn('Google Analytics measurement ID not configured');
  }
};

// Track page views
export const trackPageView = (path) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.send({ hitType: 'pageview', page: path });
  }
};

// Track custom events
export const trackEvent = (category, action, label = null, value = null) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};

// Track user interactions
export const trackUserEvent = (eventName, params = {}) => {
  if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
    ReactGA.event(eventName, params);
  }
};

// Export ReactGA for direct access if needed
export default ReactGA;